import { Controller } from "@hotwired/stimulus"
import heartBeatIcon from "../../assets/images/heart_beat.svg"

export default class extends Controller {
  static targets = [
    "container",
    "caseCount",
    "modalSccOpenButton"
  ]

  connect() {
    const caseCountTargets = this.caseCountTargets;
    if (caseCountTargets.length > 0) {
      // Use the first target for calculation, but update all
      const caseCountTarget = caseCountTargets[0];
      this.addedValue = Number(caseCountTarget.dataset.addedValue) || 0;
      this.remainingValue = Number(caseCountTarget.dataset.remainingValue) || 0;
      this.totalValue = this.addedValue + this.remainingValue;
      this.restoreSelectedCheckboxes();
      this.onCourseSelected();
    }
    this._resizeHandler = this.onCourseSelected.bind(this);
    window.addEventListener('resize', this._resizeHandler);
  }

  disconnect() {
    window.removeEventListener('resize', this._resizeHandler);

    // Only keep localStorage if still on new_batch_list page for a document set
    const batchListRegex = /\/document_sets\/(\d+)\/document_set_document_relations\/new_batch_list(\?.*)?$/;
    if (!batchListRegex.test(window.location.pathname + window.location.search)) {
      // Remove all scc_selected_checkboxes_<docSetId> keys from localStorage
      Object.keys(localStorage).forEach(key => {
        if (/^scc_selected_checkboxes_\d+$/.test(key)) {
          localStorage.removeItem(key);
        }
      });
    }
  }

  onCourseSelected() {
    this.updateIcons();
    this.updateCheckboxStates();
  }

  updateIcons() {
    const selected = this.getSelectedCheckboxCount();
    const filled = this.addedValue + selected;
    const dashed = this.totalValue - filled;
    let html = '';
    for (let i = 0; i < filled; i++) {
      html += `<div class="student-choice-cases-add-items__filled">` +
        `<img src="${heartBeatIcon}" alt="Heart Beat">` +
        `</div>`;
    }
    for (let i = 0; i < dashed; i++) {
      html += `<div class="student-choice-cases-add-items__dashed"></div>`;
    }
    this.containerTargets.forEach(container => {
      container.innerHTML = html;
    });
    setTimeout(() => {
      this.updateButtonText();
    }, 100);
  }

  updateCheckboxStates() {
    // Find all SCC checkboxes on the page
    const checkboxes = document.querySelectorAll('input.include-checkbox[data-action*="scc-selection#toggle"]');
    const selected = this.getSelectedCheckboxCount();
    const filled = this.addedValue + selected;    

    // Enable/disable checkboxes based on selection limit
    if (filled >= this.totalValue) {
      checkboxes.forEach(cb => {
        if (!cb.checked) cb.disabled = true;
      });
    } else {
      checkboxes.forEach(cb => {
        cb.disabled = false;
      });
    }
  }

  // Helper to get unique localStorage key based on document set ID in URL
  getLocalStorageKey() {
    const match = window.location.pathname.match(/\/document_sets\/(\d+)/);
    const docSetId = match ? match[1] : "default";
    return `scc_selected_checkboxes_${docSetId}`;
  }

  // Handle checkbox toggle event
  toggle(event) {
    const selected = this.getSelectedCheckboxHashes();
    const checked = event.target.checked;
    const docId = event.target.dataset.documentId;
    const documentTitle = event.target.dataset.documentTitle;
    const key = this.getLocalStorageKey();
    if (checked) {
      if (!selected.some(item => item.id === docId)) {
        selected.push({ id: docId, title: documentTitle });
        localStorage.setItem(key, JSON.stringify(selected));
      }
    } else {
      const idx = selected.findIndex(item => item.id === docId);
      if (idx !== -1) {
        selected.splice(idx, 1);
        localStorage.setItem(key, JSON.stringify(selected));
      }
    }
    this.onCourseSelected();
  }

  // Get selected checkbox from localStorage
  getSelectedCheckboxHashes() {
    const key = this.getLocalStorageKey();
    try {
      return JSON.parse(localStorage.getItem(key)) || [];
    } catch {
      return [];
    }
  }

  // Get count of selected checkboxes
  getSelectedCheckboxCount() {
    return this.getSelectedCheckboxHashes().length;
  }

  // Restore selected checkboxes from localStorage
  restoreSelectedCheckboxes() {
    const selected = this.getSelectedCheckboxHashes();
    const checkboxes = document.querySelectorAll('input.include-checkbox[data-action*="scc-selection#toggle"]');
    // Set the checked state of each checkbox based on localStorage
    checkboxes.forEach(cb => {
      const docId = cb.dataset.documentId;
      cb.checked = selected.some(item => item.id === docId);
    });
  }

  updateButtonText() {
    const selected = this.getSelectedCheckboxHashes();
    // Update all modal buttons state and text based on selected checkboxes
    this.modalSccOpenButtonTargets.forEach(btn => {
      const span = btn.querySelector('.add-items__button-text');
      if (selected.length > 0) {
        btn.disabled = false;
        if (span) {
          span.textContent = `Add ${selected.length} Selection${selected.length > 1 ? 's' : ''} to Course`;
        }
      } else {
        btn.disabled = true;
        if (span) {
          span.textContent = 'Add Selection to Course';
        }
      }
    });
  }
}
